/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Trips_Show_MoreInputs */

const en_ui_trips_show_more = /** @type {(inputs: Ui_Trips_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.count} more sessions`)
};

const de_ui_trips_show_more = /** @type {(inputs: Ui_Trips_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} weitere Einheiten anzeigen`)
};

/**
* | output |
* | --- |
* | "Show {count} more sessions" |
*
* @param {Ui_Trips_Show_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_show_more = /** @type {((inputs: Ui_Trips_Show_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Show_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_show_more(inputs)
	return de_ui_trips_show_more(inputs)
});